import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import {entityConfigs} from '../../config/entityConfigs';
import {useSettings} from '../../contexts/SettingsContext';
export default function InternalTasksPage(){const {settings}=useSettings();if(settings.moduleControls?.internalTasks===false||settings.workflowPolicy?.internalTasks===false)return <div className="empty-panel">Internal task management is disabled in Settings.</div>;return <InstituteCrudPage config={entityConfigs['internal-tasks']}/>}
